module.exports = __webpack_public_path__ + "static/media/photo33.5dc1731a.jpg";